
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[subpath]",
      function () {
        return require("private-next-pages/[subpath]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[subpath]"])
      });
    }
  